import "core-js/modules/es.array.push.js";
import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import cookie from "js-cookie";
import vailcode from "@utils/errcode";
export default {
  name: "popLucklottryLogic",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      modifyData: {},
      isUploading: false,
      isSubmit: false,
      disp_combo0: "",
      disp_combo1: "",
      disp_combo2: "",
      showOptions: false,
      gift_list: [],
      select_index: 0,
      item_list: []
    };
  },
  watch: {
    "$parent.popTaskShow": {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.showOptions = false;
          let rs = await this.$http.post("/gift/list", {
            status: 1,
            limit: 10000
          });
          if (rs.code == 0) {
            this.gift_list = rs.data.items;
          }
          let item_rs = await this.$http.post("/luckylottery/items", {
            lottery_id: this.$parent.modifyData.lottery_id,
            status: 1,
            limit: 10000
          });
          if (item_rs.code == 0) {
            this.item_list = item_rs.data;
            this.item_list.map(item => {
              if (item.gift_id > 0) item.gift_extra = JSON.parse(item.gift_extra);
            });
          }
          this.modifyData = Object.assign({}, this.$parent.modifyData);
          if (this.modifyData?.id > 0) {
            try {
              this.modifyData.disp_combo = JSON.parse(this.modifyData.disp_combo);
            } catch (e) {
              this.modifyData.disp_combo = [];
            }
          } else {
            this.modifyData.disp_combo = [];
          }
          if (this.modifyData?.gift_id > 0 && typeof this.modifyData.gift_extra == 'string' && this.modifyData.gift_extra) {
            try {
              this.modifyData.gift_extra = JSON.parse(this.modifyData.gift_extra);
            } catch (e) {
              this.modifyData.gift_extra = {};
            }
          }
          this.modifyData.disp_combo.map((item, index) => {
            this['disp_combo' + index] = item;
            this.$set(this, 'disp_combo' + index, item);
            return item;
          });
          // if(this.modifyData.reward_options){
          //   this.modifyData.reward_options = JSON.parse(this.modifyData.reward_options) ?? []
          // }
          // this.modifyData.items.map((item,index)=>{
          //   if(!this.modifyData.reward_options.includes(item.id)){
          //     item.onlyShow = 1
          //   }
          // })
        } else {
          this.$parent.getData();
          this.isSubmit = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async onConfirm() {
      if (this.isSubmit) return false;
      this.isSubmit = true;
      let data = {};
      data.id = this.modifyData.id;
      data.lottery_id = this.modifyData.lottery_id;
      data.draw_index = this.modifyData.draw_index;
      data.items = this.modifyData.items.map(item => {
        return {
          id: item.id,
          odds: item.odds,
          onlyShow: item.onlyShow ? 1 : 0
        };
      });
      let rs = await this.$http.post("/luckylottery/modifylogic", data);
      this.isSubmit = false;
      vailcode(rs, () => {
        this.$parent.getData();
        this.$parent.popTaskShow = false;
      });
    },
    async addItem() {
      if (!this.modifyData.items) {
        this.modifyData.items = [];
      }
      this.modifyData.items.push({
        id: '',
        gift_id: 0,
        onlyShow: 0,
        gift_extra: ''
      });
    }
  }
};